import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    smart_toy: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM9 8c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm4 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm2-5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
      </svg>
    ),
    people: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A2.99 2.99 0 0 0 17.15 6c-.8 0-1.54.4-1.99 1.08l-2.8 4.2c-.4.6-.1 1.42.6 1.71l3.83 1.66v4.47l-2.82-1.41-.9-.45c-.54-.27-1.2-.1-1.47.44s-.1 1.2.44 1.47l2.98 1.49c.33.17.69.25 1.06.25H20c.6 0 1-.4 1-1zM12.5 11.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5zm1.5 1h-2c-1.1 0-2 .9-2 2v5.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V18h1v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V14.5c0-1.1-.9-2-2-2z"/>
      </svg>
    ),
    attach_money: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
      </svg>
    ),
    access_time: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    ),
    speed: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.38 8.57l-1.23 1.85a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.85-1.23A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0-.27-10.44z"/>
        <path d="M10.59 15.41a2 2 0 0 0 2.83 0l5.66-8.49-8.49 5.66a2 2 0 0 0 0 2.83z"/>
      </svg>
    ),
    language: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/>
      </svg>
    ),
    record_voice_over: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <circle cx="9" cy="9" r="4"/>
        <path d="M9,15c-2.67,0-8,1.34-8,4v2h16v-2C17,16.34,11.67,15,9,15z"/>
        <path d="M16.76,5.36l-1.68,1.69c0.84,1.18,0.84,2.71,0,3.89l1.68,1.69C18.78,10.14,18.78,7.86,16.76,5.36z"/>
        <path d="M20.07,2l-1.63,1.63c2.77,3.02,2.77,7.56,0,10.74L20.07,16C23.97,12.83,23.97,7.17,20.07,2z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const AIVsAnsweringService = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'business owner'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'business owner' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const comparisonData = [
    {
      category: "Technology",
      ai: "Advanced AI conversation engine",
      answering: "Human operators with scripts",
      aiIcon: "smart_toy",
      answeringIcon: "people"
    },
    {
      category: "Response Speed",
      ai: "Instant pickup every time",
      answering: "May take 3-5 rings to answer",
      aiIcon: "speed",
      answeringIcon: "schedule"
    },
    {
      category: "Cost",
      ai: "$399/month unlimited calls",
      answering: "$500-2000+/month + per-minute fees",
      aiIcon: "attach_money",
      answeringIcon: "trending_up"
    },
    {
      category: "Availability",
      ai: "24/7/365 never offline",
      answering: "Business hours or shift-based",
      aiIcon: "checkCircle",
      answeringIcon: "access_time"
    },
    {
      category: "Consistency",
      ai: "Perfect service every single call",
      answering: "Varies by operator quality",
      aiIcon: "checkCircle",
      answeringIcon: "warning"
    },
    {
      category: "Scalability",
      ai: "Unlimited simultaneous calls",
      answering: "Limited by number of operators",
      aiIcon: "trending_up",
      answeringIcon: "people"
    },
    {
      category: "Language Support",
      ai: "Multiple languages built-in",
      answering: "Limited to operator skills",
      aiIcon: "language",
      answeringIcon: "people"
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "AI Receptionist vs Traditional Answering Service: Complete Comparison",
    "description": "Compare AI receptionists vs traditional answering services. See cost savings, 24/7 availability, and superior technology benefits.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="AI Receptionist vs Answering Service: 2025 Complete Comparison"
        description="Compare AI receptionists vs traditional answering services. See why AI costs 50% less, offers 24/7 coverage, and provides better customer service."
        keywords="ai receptionist vs answering service, ai vs traditional phone service, answering service alternative, ai phone answering, virtual receptionist comparison"
        canonical="https://receptioneer.ai/ai-vs-answering-service"
        ogTitle="AI Receptionist vs Answering Service - Why AI Wins in 2025"
        ogDescription="AI receptionists cost 50% less than traditional answering services with 24/7 availability and perfect consistency. See the comparison."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-20 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
              AI Receptionist vs
              <br />
              <span className="text-blue-200">Answering Service</span>
            </h1>
            
            <p className="text-xl text-blue-100 mb-12 leading-relaxed max-w-3xl mx-auto">
              The future vs the past. Compare advanced AI technology against traditional human operators and see why businesses are switching to AI.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="bg-white text-blue-900 hover:bg-blue-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get AI Advantage →
              </button>
              
              <a
                href="tel:+17863845350"
                className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-blue-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
              >
                <MaterialIcon name="phone" className="w-5 h-5" />
                Test AI vs Human
              </a>
            </div>

            <div className="bg-white/10 rounded-2xl p-6 max-w-2xl mx-auto">
              <div className="grid grid-cols-2 gap-6 text-center">
                <div>
                  <div className="text-3xl font-black text-red-300">$500-2000+</div>
                  <div className="text-blue-200">Traditional Service</div>
                </div>
                <div>
                  <div className="text-3xl font-black text-green-300">$399</div>
                  <div className="text-blue-200">AI Service</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Technology Evolution */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Technology <span className="text-blue-900">Evolution</span>
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="bg-white border-2 border-gray-200 rounded-3xl p-8">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="people" className="w-8 h-8 text-gray-600" />
                  <h3 className="text-2xl font-black text-gray-900">Traditional Answering Service</h3>
                </div>
                
                <div className="space-y-4 text-gray-700">
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold">1980s Technology</div>
                      <div className="text-gray-600 text-sm">Still using outdated human operator model from decades ago</div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="schedule" className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold">Human Limitations</div>
                      <div className="text-gray-600 text-sm">Inconsistent service, limited hours, varying quality</div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="trending_up" className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold">Expensive Model</div>
                      <div className="text-gray-600 text-sm">High base costs plus per-minute charges add up quickly</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-blue-900 text-white rounded-3xl p-8">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="smart_toy" className="w-8 h-8" />
                  <h3 className="text-2xl font-black">AI Receptionist</h3>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="speed" className="w-6 h-6 text-blue-200 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold">2025 AI Technology</div>
                      <div className="text-blue-100 text-sm">Advanced conversational AI with natural language understanding</div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-6 h-6 text-blue-200 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold">Perfect Consistency</div>
                      <div className="text-blue-100 text-sm">Same professional service every call, 24/7/365</div>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <MaterialIcon name="attach_money" className="w-6 h-6 text-blue-200 flex-shrink-0 mt-1" />
                    <div>
                      <div className="font-bold">Predictable Pricing</div>
                      <div className="text-blue-100 text-sm">One low monthly fee, unlimited calls included</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Detailed Comparison */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Feature-by-Feature <span className="text-blue-900">Comparison</span>
            </h2>
            
            <div className="overflow-x-auto">
              <table className="w-full bg-white rounded-3xl shadow-lg overflow-hidden">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left font-black text-gray-900">Feature</th>
                    <th className="px-6 py-4 text-center font-black text-blue-900">
                      <div className="flex items-center justify-center gap-2">
                        <MaterialIcon name="smart_toy" className="w-6 h-6" />
                        AI Receptionist
                      </div>
                    </th>
                    <th className="px-6 py-4 text-center font-black text-gray-700">
                      <div className="flex items-center justify-center gap-2">
                        <MaterialIcon name="people" className="w-6 h-6" />
                        Answering Service
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {comparisonData.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-6 font-bold text-gray-900">{item.category}</td>
                      <td className="px-6 py-6 text-center">
                        <div className="flex items-center justify-center gap-3 text-blue-900">
                          <MaterialIcon name={item.aiIcon} className="w-5 h-5" />
                          <span className="font-semibold">{item.ai}</span>
                        </div>
                      </td>
                      <td className="px-6 py-6 text-center">
                        <div className="flex items-center justify-center gap-3 text-gray-700">
                          <MaterialIcon name={item.answeringIcon} className="w-5 h-5" />
                          <span>{item.answering}</span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Cost Analysis */}
        <section className="py-16 px-6 bg-red-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              True Cost <span className="text-red-600">Analysis</span>
            </h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white rounded-3xl p-8 border-2 border-red-200">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="people" className="w-8 h-8 text-red-600" />
                  <h3 className="text-xl font-black text-gray-900">Traditional Answering Service</h3>
                </div>
                
                <div className="space-y-4">
                  <div className="flex justify-between items-center py-2 border-b border-red-100">
                    <span className="text-gray-700">Base monthly fee:</span>
                    <span className="font-bold text-red-600">$500-800</span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-red-100">
                    <span className="text-gray-700">Per-minute charges:</span>
                    <span className="font-bold text-red-600">$0.50-2.00</span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-red-100">
                    <span className="text-gray-700">Setup fees:</span>
                    <span className="font-bold text-red-600">$100-500</span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-red-100">
                    <span className="text-gray-700">After-hours premium:</span>
                    <span className="font-bold text-red-600">+50%</span>
                  </div>
                  <div className="flex justify-between items-center py-3 bg-red-100 rounded-xl px-4">
                    <span className="font-bold text-red-800">Monthly Total:</span>
                    <span className="text-2xl font-black text-red-600">$800-2000+</span>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-3xl p-8 border-2 border-blue-200">
                <div className="flex items-center gap-3 mb-6">
                  <MaterialIcon name="smart_toy" className="w-8 h-8 text-blue-600" />
                  <h3 className="text-xl font-black text-gray-900">AI Receptionist</h3>
                </div>
                
                <div className="space-y-4">
                  <div className="flex justify-between items-center py-2 border-b border-blue-100">
                    <span className="text-gray-700">Monthly subscription:</span>
                    <span className="font-bold text-blue-600">$399</span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-blue-100">
                    <span className="text-gray-700">Per-call charges:</span>
                    <span className="font-bold text-blue-600">$0</span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-blue-100">
                    <span className="text-gray-700">Setup fees:</span>
                    <span className="font-bold text-blue-600">$0</span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b border-blue-100">
                    <span className="text-gray-700">After-hours premium:</span>
                    <span className="font-bold text-blue-600">$0</span>
                  </div>
                  <div className="flex justify-between items-center py-3 bg-green-100 rounded-xl px-4">
                    <span className="font-bold text-green-800">Monthly Total:</span>
                    <span className="text-2xl font-black text-green-600">$399</span>
                  </div>
                </div>
                
                <div className="mt-6 p-4 bg-green-50 rounded-xl">
                  <div className="text-center">
                    <div className="text-sm font-bold text-green-800">Annual Savings</div>
                    <div className="text-2xl font-black text-green-600">$4,800-$19,200</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Businesses Switch */}
        <section className="py-16 px-6 bg-blue-50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Why Businesses Are <span className="text-blue-900">Switching</span>
            </h2>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-3xl p-8 text-center">
                <MaterialIcon name="attach_money" className="w-12 h-12 text-green-600 mx-auto mb-4" />
                <h3 className="text-xl font-black mb-4">Save 50-80%</h3>
                <p className="text-gray-600">Cut phone answering costs in half while getting better service quality and 24/7 coverage.</p>
              </div>

              <div className="bg-white rounded-3xl p-8 text-center">
                <MaterialIcon name="checkCircle" className="w-12 h-12 text-blue-600 mx-auto mb-4" />
                <h3 className="text-xl font-black mb-4">Perfect Consistency</h3>
                <p className="text-gray-600">Every call gets the same professional, accurate service. No more varying quality between operators.</p>
              </div>

              <div className="bg-white rounded-3xl p-8 text-center">
                <MaterialIcon name="speed" className="w-12 h-12 text-purple-600 mx-auto mb-4" />
                <h3 className="text-xl font-black mb-4">Instant Setup</h3>
                <p className="text-gray-600">Ready in 24 hours vs weeks of training and setup with traditional services.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Real Problems with Traditional Services */}
        <section className="py-16 px-6 bg-gray-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Problems with Traditional <span className="text-red-600">Services</span>
            </h2>
            
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 border-l-4 border-red-500">
                <div className="flex items-start gap-4">
                  <MaterialIcon name="warning" className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Inconsistent Quality</h3>
                    <p className="text-gray-600">Service varies dramatically between different operators. Some are great, others are unprofessional or make mistakes.</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 border-l-4 border-orange-500">
                <div className="flex items-start gap-4">
                  <MaterialIcon name="schedule" className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Limited Hours</h3>
                    <p className="text-gray-600">Most services only operate during business hours or charge premium rates for after-hours coverage.</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 border-l-4 border-yellow-500">
                <div className="flex items-start gap-4">
                  <MaterialIcon name="trending_up" className="w-6 h-6 text-yellow-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Unpredictable Costs</h3>
                    <p className="text-gray-600">Per-minute charges can result in shocking monthly bills, especially during busy periods.</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 border-l-4 border-red-500">
                <div className="flex items-start gap-4">
                  <MaterialIcon name="people" className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">Capacity Limitations</h3>
                    <p className="text-gray-600">During busy periods, calls get backed up in queues or go to voicemail because all operators are busy.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 px-6 bg-blue-900 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              Ready to Upgrade to AI?
            </h2>
            
            <p className="text-xl text-blue-100 mb-12">
              Join thousands of businesses that have already switched to superior AI phone answering technology.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="grid md:grid-cols-3 gap-6 text-center mb-8">
                <div>
                  <div className="text-3xl font-black mb-2">$399</div>
                  <div className="text-blue-200">per month total</div>
                </div>
                <div>
                  <div className="text-3xl font-black mb-2">24/7</div>
                  <div className="text-blue-200">always available</div>
                </div>
                <div>
                  <div className="text-3xl font-black mb-2">50-80%</div>
                  <div className="text-blue-200">cost savings</div>
                </div>
              </div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-blue-900 hover:bg-blue-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Switch to AI Today →
              </button>
            </div>
            
            <p className="text-blue-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Upgrade to AI"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Welcome to the future!</h3>
              <p className="text-gray-600">Your AI receptionist will be ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. Sarah Johnson"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="sarah@business.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-blue-900 hover:bg-blue-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get AI Receptionist'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/ai-vs-answering-service" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AIVsAnsweringService;